module.exports = __webpack_public_path__ + "static/media/consultingSchemaMobile.e41076d4.svg";